import {createFileRoute} from '@tanstack/react-router';

import {WhatsNewPage} from '@/modules/whats-new/pages/WhatsNewPage';

export const Route = createFileRoute('/_authenticated/whats-new/')({
  component: WhatsNewPage,
});
